import { AccountBalanceOutlined } from '@mui/icons-material'
import BusinessIcon from '@mui/icons-material/Business'
import CurrencyPoundIcon from '@mui/icons-material/CurrencyPound'
import GroupsIcon from '@mui/icons-material/Groups'
import NoteIcon from '@mui/icons-material/Note'
import PeopleIcon from '@mui/icons-material/People'
import WorkspacesIcon from '@mui/icons-material/Workspaces'
import { Box, Tab, Tabs } from '@mui/material'
import Billing from 'components/Clients/ClientManagement/Billing/Billing'
import Delegates from 'components/Clients/ClientManagement/Delegate/Delegates'
import FixedRoutes from 'components/Clients/ClientManagement/FixedRoutes/FixedRoutes'
import TaxiRates from 'components/Clients/ClientManagement/TaxiRates/TaxiRates'
import { Users } from 'components/Clients/ClientManagement/Users/Users'
import useClient from 'hooks/useClient'
import useUserRole from 'hooks/useUserRole'
import { useState } from 'react'
import questionIcon from '../../../assets/icon/Icon-question.svg'
import BookingReferences from '../../../components/Clients/ClientManagement/BookingReferences/BookingReferences'
import Company from '../../../components/Clients/ClientManagement/Company/Company'
import UserProfiles from '../../../components/Clients/ClientManagement/UserProfiles/UserProfiles'
import BaseLayout from '../../../layouts/Base/BaseLayout'
import styles from './clientManagementPageStyle'

function a11yProps(index: number) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  }
}

export function ClientManagementPage(props: any) {
  const [value, setValue] = useState(0)
  const { validateAccess } = useUserRole()
  const clientResult = useClient(Number(props.match.params.id), true, true)
  const { client, isLoading } = clientResult || {}

  const handleChange = (event: any, newValue: any) => {
    setValue(newValue)
    clientResult?.refetch && clientResult.refetch()
  }
  console.log(client)
  return !isLoading && client !== undefined ? (
    <div>
      {client?.alias ? (
        <BaseLayout
          pageIcon={questionIcon}
          pageTitle={client.alias}
          pageSubtitle={client.companyName}
          wideLayout={true}
        />
      ) : (
        <BaseLayout
          pageIcon={questionIcon}
          pageTitle={client?.companyName}
          pageSubtitle="Company details"
          wideLayout={true}
        />
      )}

      <Box component={'div'} sx={styles.root}>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons
          indicatorColor="primary"
          textColor="primary"
          orientation="vertical"
          sx={styles.componentPanel}
          allowScrollButtonsMobile
        >
          <Tab label="Company" icon={<BusinessIcon />} {...a11yProps(0)} />
          {client.platform.platformInvoiceTypeName === 'Client' ? (
            <Tab
              label="Billing"
              icon={<AccountBalanceOutlined />}
              {...a11yProps(1)}
            />
          ) : (
            <></>
          )}
          <Tab label="Users" icon={<PeopleIcon />} {...a11yProps(2)} />
          <Tab
            label="Booking References"
            icon={<NoteIcon />}
            {...a11yProps(3)}
          />
          <Tab label="Delegates" icon={<GroupsIcon />} {...a11yProps(4)} />
          <Tab
            label="User Profiles"
            icon={<WorkspacesIcon />}
            {...a11yProps(5)}
          />
          {(validateAccess('Jyrney_admin') ||
            validateAccess('Platform_admin')) && (
            <Tab
              label="Mileage Rates"
              icon={<CurrencyPoundIcon />}
              {...a11yProps(6)}
            />
          )}
          {(validateAccess('Jyrney_admin') ||
            validateAccess('Platform_admin')) && (
            <Tab
              label="Fixed Routes"
              icon={<CurrencyPoundIcon />}
              {...a11yProps(7)}
            />
          )}
        </Tabs>
        {value === 0 && <Company client={client} />}
        {value === 1 && client.platform.platformInvoiceTypeName === 'Client' ? (
          <Billing client={client} />
        ) : (
          <></>
        )}
        {value === 2 && <Users client={client} />}
        {value === 3 && <BookingReferences client={client} />}
        {value === 4 && <Delegates client={client} />}
        {value === 5 && <UserProfiles client={client} />}
        {value === 6 && <TaxiRates client={client} />}
        {value === 7 && <FixedRoutes client={client} />}
      </Box>
    </div>
  ) : (
    <>Loading</>
  )
}

export default ClientManagementPage
